import Vue from 'vue'
import Router from 'vue-router'
import Interventions from '@/components/Interventions'
import Intervention from '@/components/Intervention'
import Debrief from '@/components/Debrief'
import Account from '@/components/Account'
import AuditPM from '@/components/AuditPM'
import AuditConstatation from '@/components/AuditConstatation'
import Authentification from '@/components/Authentification'
import Home from '@/components/Home'
import Scan from '@/components/Scan'
import Accueil from '@/components/Accueil'
import TestArbre from '@/components/TestArbre'
Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/app',
      component: Home,
      children: [
        {
          path: '/interventions/:type/:status',
          component: Interventions
        },
        {
          path: '/intervention/:intervention_id',
          component: Intervention
        },
        {
          path: '/intervention/:intervention_id/debrief',
          component: Debrief
        },
        {
          path: '/intervention/:intervention_id/auditpm',
          component: AuditPM
        },
        {
          path: '/intervention/:intervention_id/auditconstatation',
          component: AuditConstatation
        },
        {
          path: '/account',
          component: Account
        },
        {
          path: '/scan',
          component: Scan
        },
        {
          path: '/accueil',
          component: Accueil
        },
        {
          path: '/testarbre',
          component: TestArbre
        }
      ]
    },
    {
      path: '/',
      component: Authentification
    },
    {
      path: '*',
      redirect: '/'
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js